import React, { useState } from 'react'
import Modal from '../../Modal'
import Button from '../../Button'

import Icon from '../../Icon'
import { MessageCreate, Upload } from '../type'
import { Actions, ModalContent as Container } from './styles'
import { useRequest } from '@polvo-labs/react-auth'
import { toast } from 'react-toastify'
import Loader from '../../Loader'

// declare const MediaRecorder: any

interface Props {
  onChange: (message: MessageCreate) => void
}

const Audio: React.FC<Props> = ({ onChange }) => {
  const [open, setOpen] = useState(false)
  const [audio, setAudio] = useState<{ upload: Upload, duration: number }>()
  const { request } = useRequest()
  const [uploading, setUploading] = useState(false)
  const [recording, setRecording] = useState()

  const handleStartRecord = () => {
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      const mediaRecorder = new MediaRecorder(stream, { mimeType: 'audio/webm' })
      const started = Date.now()
      mediaRecorder.start()

      const audioChunks: Blob[] = []

      mediaRecorder.ondataavailable = event => {
        audioChunks.push(event.data)
      }

      mediaRecorder.onstop = () => {
        const duration = Date.now() - started
        const audioBlob = new Blob(audioChunks, {
          type: 'audio/webm',
        })

        const formData = new FormData()
        formData.append('files[]', audioBlob)

        request({
          method: 'POST',
          url: `${process.env.REACT_APP_API_URL}/chat/uploads`,
          data: formData,
        }).then(({ data }) => {
          toast.info('Upload realizado com sucesso')
          setUploading(false)
          if (data && data.data) {
            setAudio({
              upload: data.data[0],
              duration,
            })
          }
        }).catch(() => {
          toast.error('Ocorreu um erro ao fazer o upload')
          setUploading(false)
        })
      }

      setRecording(mediaRecorder)
    })
  }

  const handleStopRecord = () => {
    recording.stop()

    setRecording(undefined)
  }

  return (
    <>
      <Button
        before={(
          <Icon
            name="audio"
          />
        )}
        label="Gravar áudio"
        backgroundColor="transparent"
        fontColor="darkGray"
        smallPadding
        alignText="flex-start"
        onClick={() => setOpen(true)}
      />

      <Modal
        open={open}
        onToggle={open => {
          setAudio(undefined)
          setOpen(open)
        }}
      >
        <Container>

          {audio && (
            <audio
              controls
              controlsList="nodownload"
            >
              <source
                src={audio.upload.url}
                type="audio/mpeg"
              />
            </audio>
          )}

          <Actions>
            {recording ? (
              <Button
                label="Parar gravação"
                backgroundColor="red"
                onClick={handleStopRecord}
              />
            ) : !audio && (
              <Button
                label="Começar a gravar"
                onClick={handleStartRecord}
              />
            )}

            {audio && (
              <>
                <Button
                  label="ESCOLHER ÁUDIO"
                  onClick={() => {
                    onChange({
                      type: 'AUDIO',
                      ...audio,
                    })
                    setOpen(false)
                  }}
                />

                <Button
                  label="REMOVER ÁUDIO"
                  backgroundColor="red"
                  onClick={() => setAudio(undefined)}
                />
              </>
            )}
          </Actions>
        </Container>

        {uploading && (
          <Loader
            full
          />
        )}
      </Modal>
    </>
  )
}

export default Audio
